export const ApiConstants = {
    checkTenantcode: '/auth/validate-tenant',
    login: '/auth/login',
    getLoginOtp: '/auth/send-otp',
    varifyLoginOtp: '/auth/verify-otp',
    renewJWT: '/auth/refresh',
    forgotPassword: '/auth/forgot-password',
    changePassword: '/auth/change-password',
    toResetPassword: '/auth/reset-password',
    addRoleName: '/admin/api/roles',
    appMenus: '/admin/api/app-menus',
    getAllroles: '/admin/api/roles',
    updateRole: '/admin/api/roles',
    assignMenuToRole: '/admin/api/roles/{roleId}/menus',
    getMyMenus: '/admin/api/users/me/menus',
    getMenusAssignedToRoles: '/admin/api/roles/{roleId}/menus',
    getProfileInfo: '/admin/api/users/me/profile',
    getCompanyInfo: '/admin/api/company',
    updateCompanyInfo: '/admin/api/company',
    locationSetup: '/admin/api/locations',
    SiteSetup: '/admin/api/sites?locationId=',
    addUpdateSiteInfo: '/admin/api/sites',
    venderSetup: '/admin/api/vendors',
    vendorStsUpdate: '/admin/api/vendors/{id}/status',
    userSetup: '/admin/api/users',
    userStatusChange: '/admin/api/users/{id}/status',
    foodTypeSetUp: '/admin/api/menu/food-types',
    foodTypeSts: '/admin/api/menu/food-types/{id}/status',
    cafeteriaSetup: '/admin/api/cafeterias',
    cafeteriaSts: '/admin/api/cafeterias/{id}/status',
    mealTypeSts: '/admin/api/menu/meal-types/{id}/status',
    mealTypeSetup: '/admin/api/menu/meal-types',
    categoriesSts: '/admin/api/menu/categories/{id}/status',
    categoriesSetup: '/admin/api/menu/categories',
    menuItemSts: '/admin/api/menu/items/{id}/status',
    menuItemSetup: '/admin/api/menu/items',
    cafeMenuUpdate: '/admin/api/cafeterias/menu',
    cafeMenuStsChange: '/admin/api/cafeterias/menu/{menuId}/status',
    cafeMenus: '/admin/api/cafeterias/{id}/menu',
    getCafeTimeSlot: '/admin/api/cafeterias/menu/{menuId}/time-slots',
    cafeTimeslotaddEdit: '/admin/api/cafeterias/menu/time-slots',
    cafeTimeSlotStsUpdate: '/admin/api/cafeterias/menu/time-slots/{id}/status',
    addEditCafeDiscount: '/admin/api/cafe-menu-discounts',
    cafeDiscountStsChange: '/admin/api/cafe-menu-discounts/{id}/status',
    getCafeDiscountInfo: '/admin/api/cafe-menu-discounts/menu/{cafeMenuId}',
    addEditcafeSplOffer: '/admin/api/special-offers',
    cafeSplOfferStsUpdate: '/admin/api/special-offers/{id}/status',
    getCafeSplOffer: '/admin/api/special-offers/cafeteria/{cafeteriaId}',
    getAllAutherizationMenus: '/admin/api/app-menus/all',
    adminMenuUtilizationReport: '/report/api/admin/reports/menu-utilization',
    adminBookingReport: '/report/api/admin/reports/bookings',
    vendorMenuUtilizationReport: '/report/api/vendor/menu-utilization',
    vendorBookingReport: '/report/api/vendor/bookings',
    getCafeteriaByMultivendorId: '/admin/api/cafeterias/by-vendors/all',
    getVenderInfoByUserId: '/admin/api/vendors/by-user/{userId}',
    getRevenueReport: '/report/api/admin/reports/vendor-revenue',
    getVendorSalesReport: '/report/api/admin/reports/vendor-sales',
    getOrderAccuracyReport: '/report/api/admin/reports/order-accuracy',
    customerRatingsByVender: '/report/api/admin/reports/customer-ratings-by-vendor',
    userRatingsAndFeedback: '/report/api/admin/reports/user-feedback',
    vendorRanking: '/report/api/admin/reports/vendor-ranking',
    mealServed: '/report/api/admin/reports/meals-served',
    orderDetails: '/report/api/admin/reports/order-accuracy/order-details',
    getAllVendors: '/admin/api/vendors/list',
    getAllCafeterias: '/admin/api/cafeterias/list',
    getAllFoodTypes: '/admin/api/menu/food-types/list',
    getAllMenuItems: '/admin/api/menu/items/list',
    getAllMealTypes: '/admin/api/menu/meal-types/list',
    getAllCategories: '/admin/api/menu/categories/list',
    getCafeteriaMenuItem: '/admin/api/cafeterias/{id}/menu/list',
}
